import { authenticatedFetch } from "@beholos/holoscommon";
import type { Awards } from "../components/awards/ProgressSection";
import type { Level } from "../types/level.interface";
import { API_BASE_URL } from "./constants";

export const getAwards = async (): Promise<Awards> => {
  try {
    const response = await authenticatedFetch(`${API_BASE_URL}/awards`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    return data;
  } catch (error: any) {
    console.error('Error fetching levels:', error);
    throw new Error('Se ha producido un error.');
  }
};

export const acceptReward = async (): Promise<boolean> => {
  try {
    const response = await authenticatedFetch(`${API_BASE_URL}/awards/accept`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    return data;
  } catch (error: any) {
    console.error('Error fetching levels:', error);
    throw new Error('Se ha producido un error.');
  }
};

export interface RedeemPointsResponse {
  message: string;
  success: boolean;
}

export const redeemPoints = async (points: string): Promise<RedeemPointsResponse> => {
  try {
    const response = await authenticatedFetch(`${API_BASE_URL}/awards/redeem`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ points }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    return data;
  } catch (error: any) {
    console.error('Error redeeming points:', error);
    return {
      success: false,
      message: 'Error al canjear puntos.'
    };
  }
};

export const getLevels = async (): Promise<Level[]> => {
  try {
    const response = await authenticatedFetch(`${API_BASE_URL}/awards/levels`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    return data;
  } catch (error: any) {
    console.error('Error fetching levels:', error);
    throw new Error('Se ha producido un error.');
  }
};